import React from "react";

function ResetIcon({ width = "108", height = "44", label = "Reset" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 108 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_301_2888)">
        <rect width="108" height="44" rx="22" fill="#4072C8" />

        <text
          x="54"
          y="27"
          textAnchor="middle"
          fill="white"
          fontSize="18"
          fontFamily="Inter, Arial, sans-serif"
          fontWeight="500"
        >
          {label}
        </text>
      </g>

      <defs>
        <filter
          id="filter0_i_301_2888"
          x="0"
          y="-1"
          width="108"
          height="45"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0.0705882 0 0 0 0 0.278431 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_301_2888"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default ResetIcon;
